// Portraits come in two sizes (see scripts/optimize-images.mjs):
//   <name>.webp      900px wide — desktop, where .doctor-card img is width: 40%
//   <name>@600.webp  600px wide — phones, where it is width: 100%
// Doctors.jsx picks srcPhone below 600px viewport width.
import staff112 from "./images/staff/staff112.webp";
import staff112Phone from "./images/staff/staff112@600.webp";
import staff222 from "./images/staff/staff222.webp";
import staff222Phone from "./images/staff/staff222@600.webp";
import staff442 from "./images/staff/staff442.webp";
import staff442Phone from "./images/staff/staff442@600.webp";
import staff552 from "./images/staff/staff552.webp";
import staff552Phone from "./images/staff/staff552@600.webp";

const doctors = [
  {
    src: staff112,
    srcPhone: staff112Phone,
    name: "Fizioterapeut Andrei Pogangeanu",
    description:
      "Salut, ma numesc Andrei Pogangeanu si sunt un fizioterapeut specializat in recuperare spinala si neurologica.",
    cv: "",
  },
  {
    src: staff222,
    srcPhone: staff222Phone,
    name: "Fizioterapeut Raluca Pogangeanu",
    description:
      "Buna, ma numesc Raluca Pogangeanu si sunt un fizioterapeut principal specializat in recuperare afectiuni ortopedie - traumatologie.",
    cv: "",
  },
  // Alexandra Oprisor — inactive. To restore, add back:
  //   import staff333 from "./images/staff/staff333.webp";
  //   import staff333Phone from "./images/staff/staff333@600.webp";
  // {
  // 	src: staff333,
  // 	srcPhone: staff333Phone,
  // 	name: "Fizioterapeut Alexandra Oprisor",
  // 	description:
  // 		"Buna, ma numesc Alexandra Oprisor si sunt un fizioterapeut specializat in electroterapie si masaj terapeutic.",
  // 	cv: "",
  // },
  {
    src: staff442,
    srcPhone: staff442Phone,
    name: "Fizioterapeut Alexandru Stan",
    description:
      "Salut, ma numesc Alexandru Stan si sunt un fizioterapeut specializat in terapie manuala.",
    cv: "",
  },
  {
    src: staff552,
    srcPhone: staff552Phone,
    name: "Fizioterapeut Alice Bancila",
    description:
      "Buna, ma numesc Alice Bancila si sunt un fizioterapeut specializat in kinetoterapie si electroterapie.",
    cv: "",
  },
  // Marioara Tuță — inactive. To restore, add back:
  //   import staff662 from "./images/staff/staff662.webp";
  //   import staff662Phone from "./images/staff/staff662@600.webp";
  //   {
  //     src: staff662,
  //     srcPhone: staff662Phone,
  //     name: "Fizioterapeut Marioara Tuță",
  //     description:
  //       "Buna, ma numesc Marioara Tuță si sunt un fizioterapeut specializat in fizioterapie, kinetoterapie si masaj terapeutic.",
  //     cv: "",
  //   },
];

export default doctors;
